// extracted by mini-css-extract-plugin
export var scrollUp = "ScrollToTop-module--scroll-up--3tA3d";